import styled from 'styled-components';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { SetToastPortalWrapper } from '@/store/toast/actions';

import { OverlayInterface } from './OverlayInterface';

const CloseIconContainer = styled.div<{ isMobile: boolean }>`
    width: 100%;
    height: ${({ isMobile }): number => (isMobile ? 64 : 68)}px;
    svg {
        top: ${({ isMobile }): number => (isMobile ? 22 : 24)}px;
        right: ${({ isMobile }): number => (isMobile ? 16 : 24)}px;
        position: absolute;
        cursor: pointer;
    }
`;

const ContentContainer = styled.div`
    padding: 0px 16px;
`;

const DialogWrapper = styled.div`
    overflow-y: overlay;
`;

export const OverlayComponent: FC<OverlayInterface> = ({ onClose, open, children }: OverlayInterface): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(SetToastPortalWrapper(true));

        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, []);

    return (
        <Portal>
            <MaterialDialog open={open} fullScreen={true} onClose={onClose}>
                <DialogWrapper>
                    <CloseIconContainer isMobile={false}>
                        <CloseIcon onClick={onClose} />
                    </CloseIconContainer>
                    <ContentContainer>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                                {children}
                            </Grid>
                        </Grid>
                    </ContentContainer>
                </DialogWrapper>
            </MaterialDialog>
        </Portal>
    );
};
